import React from 'react'
import { VIEW_MAPS_MARKERS, VIEW_MAPS_POLYLINE } from '../../view-utils'
import ConfigDefault from './ConfigDefault'
import ConfigMapPolyline from './ConfigMarkerPolyline'
import ConfigMapMarkers from './ConfigMapMarkers'

const Config = ({ config = {}, onChange }: any) => {
    const {
        steps,
        zoom,
        view,
        perspectives,
        btnFilters, // RETROCOMPATIBILIDADE
        btnFiltersAND,
        btnFiltersOR,
        extensionQualifier,
        maxSpeed,
        positionsReportId,
        tripsReportId
    } = config

    const renderConfigs = view => {
        switch (view) {
            case VIEW_MAPS_POLYLINE:
                return <ConfigMapPolyline steps={steps} onChange={onChange} />
            case VIEW_MAPS_MARKERS:
                return (
                    <ConfigMapMarkers
                        perspectives={perspectives}
                        btnFiltersOR={!btnFiltersOR ? btnFilters : btnFiltersOR}
                        btnFiltersAND={btnFiltersAND}
                        onChange={onChange}
                        maxSpeed={maxSpeed}
                    />
                )
        }
    }

    return (
        <>
            <ConfigDefault extensionQualifier={extensionQualifier} zoom={zoom} view={view} onChange={onChange}  positionsReportId={positionsReportId} tripsReportId={tripsReportId}/>

            <br />

            {view && renderConfigs(view)}
        </>
    )
}

export default Config
